import { render, staticRenderFns } from "./SimilarityStringDiff.vue?vue&type=template&id=48afe931"
import script from "./SimilarityStringDiff.vue?vue&type=script&lang=js"
export * from "./SimilarityStringDiff.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports